import { render, staticRenderFns } from "./AxFormSuccess.vue?vue&type=template&id=86dd80fc&scoped=true&"
import script from "./AxFormSuccess.vue?vue&type=script&lang=ts&"
export * from "./AxFormSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AxFormSuccess.vue?vue&type=style&index=0&id=86dd80fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dd80fc",
  null
  
)

export default component.exports